import React from 'react';

import TimeToPrepareInput from './TimeToPrepareInput';

const TimeToPrepareInputForm = ({ value, onChange, errorMessage }) => {
  return (
    <TimeToPrepareInput
      errorMessage={errorMessage}
      timeToPrepare={value}
      setTimeToPrepare={onChange}
    ></TimeToPrepareInput>
  );
};

export default TimeToPrepareInputForm;
